import { server } from "../utils/server";

const createTokenTransferTransaction = (data) => {
    return server.post("/tokentransfertransactions/sendTokenTransferTransaction", data)
    .then((res) => {
        return res.data;
    })
    .catch((err) => {
        return err?.response?.data;
    });
}

const getTokenTransferTransactions = (investorId) => { 
    return server.get(`/tokentransfertransactions/recieveAndSendTokenTransferTransaction/${investorId}`)
    .then((res) => {
        return res.data;
    })
    .catch((err) => {
        return err?.response?.data;
    });
}

const statusUpdate = (data) => {
    return server.post("/tokentransfertransactions/statusUpdate", data)
    .then((res) => {
        return res.data;
    })
    .catch((err) => {
        return err?.response?.data;
    });
}

const getOptinTransactions = (data) => {
    return server.post("/tokentransfertransactions/getOptinTransactions", data)
    .then((res) => {
        return res.data;
    })
    .catch((err) => {
        return err?.response?.data;
    });
}
const tokenTransferServices = {
    createTokenTransferTransaction,
    getTokenTransferTransactions,
    statusUpdate,
    getOptinTransactions
}

export default tokenTransferServices;